export enum UserRole {
  INVESTOR = 'investor',
  RENTER = 'renter',
}
